import { default_state } from "../default_state";
// import { setUserLocalStorage } from "../../logic/data/localStorage";
export default function user(state = default_state.filter, action) {
	const { type } = action;
	switch (type) {
		default:
			return state;
	}
}
